import { enableProdMode, isDevMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { DevAWSSettings, ProdAWSSettings } from "./awsconfig";
import { Amplify } from 'aws-amplify'

if (environment.production) {
  enableProdMode();
}

let setting = isDevMode() ? new DevAWSSettings() : new ProdAWSSettings();

//Amplify.Logger.LOG_LEVEL = 'VERBOSE';
Amplify.configure(setting.value);



platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => {
    //console.error(err)
  });
